import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IPickupForSearch } from '../../../model/interfaces/custom/pickup-for-search';
import { PickupStatus } from '../../order-basic-info/pickup-status-enum';

@Component({
    selector: 'pickup-calendar-table-dialog',
    templateUrl: './pickup-calendar-table-dialog.component.html',
    styleUrls: ['./pickup-calendar-table-dialog.component.css'],
    standalone: false
})
export class PickupCalendarTableDialogComponent {
    @Input() pickups: IPickupForSearch[] = [];
    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

    PickupStatus = PickupStatus;

    constructor(private router: Router) {}

    close(): void {
        this.onClose.emit();
    }

    totalPrePayment(pickup: IPickupForSearch): number {
        if (!pickup.PickupPaymentDetails) return 0;

        return pickup.PickupPaymentDetails.filter((d) => d.IsSuccessful).reduce((sum, cur) => sum + cur.Amount, 0);
    }

    totalRemainingBalance(pickup: IPickupForSearch): number {
        const remaining = pickup.SecurityGateFee - this.totalPrePayment(pickup);
        return remaining > 0 ? remaining : 0;
    }

    goToPickupsPage(): void {
        if (!this.pickups?.length) return;

        const pickupNumbers = this.pickups.map((p) => p.PickupNumber).join(',');

        const url = `#/create-requests/manage-pickups?pickupNumbers=${encodeURIComponent(pickupNumbers)}`;

        window.open(url, '_blank'); // Opens in new tab

        this.close();
    }
}
